<ng-container *ngIf="!isMaintenance">
    <div id="siteheader" [hidden]="!(showHeader$ | async)">
        <div class="container">
            <div class="headercontent" [ngClass]="{ no_mobile_search: !showMobileSearch }">
                <ng-container *ngIf="showLinksInHeader$ | async">
                    <ng-container *ngTemplateOutlet="headerWithLinks"></ng-container>
                </ng-container>
                <ng-container *ngIf="!(showLinksInHeader$ | async)">
                    <ng-container *ngTemplateOutlet="headerWithLogoOnly"></ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #headerWithLogoOnly>
    <div class="logocontainer">
        <span id="logo">
            <span>Dräger</span>
            <ng-container *ngIf="partnerPortalLink$ | async as portalLink">
                <a da-link [routerLink]="portalLink | localize">
                    <span>Dräger</span>
                    <img [src]="logo" />
                </a>
            </ng-container>

            <ng-container *ngIf="!(partnerPortalLink$ | async)">
                <img [src]="logo" />
            </ng-container>
        </span>
    </div>
    <ng-container *ngIf="(isPortal$ | async) && portalId !== 'de-ext'">
        <div class="header-top">
            <a *ngIf="hasSupportLinkInHeader$ | async" (click)="scrollTo('contact-us')">
                <span class="drg-icon-help"></span>
                <span class="support-link" [innerHTML]="'supportHeaderLink' | translate"></span>
            </a>
            <da-login *ngIf="showLogin$ | async"></da-login>
            <da-my-account class="my-login" *ngIf="showLogout$ | async"></da-my-account>
            <da-language-country-switcher></da-language-country-switcher>
        </div>

        <div id="sitenavigation">
            <da-site-navigation></da-site-navigation>
        </div>
    </ng-container>
</ng-template>
<ng-template #headerWithLinks>
    <div class="logocontainer">
        <span id="logo">
            <a da-link [routerLink]="'/home' | localize">
                <span>Dräger</span>
                <img [src]="logo" />
            </a>
        </span>
    </div>
    <div class="header-top">
        <div class="inner-wrapper">
            <da-login *ngIf="showLogin$ | async"></da-login>
            <da-my-account class="my-login" *ngIf="showLogout$ | async"></da-my-account>
            <da-language-country-switcher></da-language-country-switcher>
            <a *ngIf="showSearch$ | async" class="toggle-search primary button" (click)="toggleSearch()" href="javascript:;"></a>
        </div>
    </div>
    <ng-container *ngIf="showSearch$ | async">
        <div class="search-wrapper" *ngIf="showMobileSearch">
            <da-auto-complete-search-v3 *ngIf="showSearch$ | async" [config]="configSearch"></da-auto-complete-search-v3>
        </div>
    </ng-container>
    <ng-container>
        <div id="sitenavigation" class="main-nav" [ngClass]="{ no_search: !(showSearch$ | async) }">
            <da-site-navigation></da-site-navigation>
            <da-auto-complete-search-v3 *ngIf="showSearch$ | async" [config]="configSearch"></da-auto-complete-search-v3>
        </div>
    </ng-container>
</ng-template>

<ng-container *ngIf="isMaintenance">
    <div id="siteheader">
        <div class="container">
            <div class="headercontent" [ngClass]="{ no_mobile_search: !showMobileSearch }">
                <div class="logocontainer">
                    <span id="logo">
                        <span>Dräger</span>
                        <ng-container>
                            <img [src]="logo" />
                        </ng-container>
                    </span>
                </div>
            </div>
        </div>
    </div>
</ng-container>
